import { render, staticRenderFns } from "./carinfo.vue?vue&type=template&id=5c3913d2&"
import script from "./carinfo.vue?vue&type=script&lang=js&"
export * from "./carinfo.vue?vue&type=script&lang=js&"
import style0 from "./carinfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports